import styled from 'styled-components';

/* Option */

const OPTION_DIRECTION_MAP = {
    TOP: {
        flexDirection: 'column',
        margin: '8px 0 0 0',
    },
    RIGHT: {
        flexDirection: 'row-reverse',
        margin: '0 8px 0 0',
    },
    BOTTOM: {
        flexDirection: 'column-reverse',
        margin: '0 0 8px 0',
    },
    LEFT: {
        flexDirection: 'row',
        margin: '0 0 0 8px',
    },
};

export const OptionContainer = styled.div`
    display: flex;
    flex-direction: ${({ direction }) => OPTION_DIRECTION_MAP[direction].flexDirection};
    margin: ${({ margin }) => margin};
`;

export const OptionClickableContainer = styled.div`
    display: flex;
    flex-direction: ${({ direction }) => OPTION_DIRECTION_MAP[direction].flexDirection};
    cursor: pointer;
`;

export const OptionText = styled.p`
    font-size: 13px;
    text-align: left;
    margin: ${({ direction }) => OPTION_DIRECTION_MAP[direction].margin};
`;

/* RadioList */

export const RadioListContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    width: 100%;
    margin: ${({ margin }) => margin};
`;

export const RadioBackground = styled.div`
    background-color: ${({ value, theme }) => (value ? theme.colors.primary300 : theme.colors.neutral000)};
    border-radius: 100px;
    border: ${({ size }) => (size > 16 ? Math.floor(size / 16) : 1)}px solid ${({ value, theme }) => (value ? theme.colors.primary300 : theme.colors.neutral700)};
    width: ${({ size }) => size}px;
    height: ${({ size }) => size}px;
    position: relative;
    cursor: ${({ value }) => (value ? 'default' : 'pointer')};
`;

export const RadioSelected = styled.div`
    background-color: ${({ theme }) => theme.colors.white};
    border-radius: 100px;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.25);
    width: ${({ size }) => Math.floor(size / 2)}px;
    height: ${({ size }) => Math.floor(size / 2)}px;
    position: absolute;
    top: ${({ size }) => Math.floor(size / 4)}px;
    left: ${({ size }) => Math.floor(size / 4)}px;
`;
